'use strict';

var centralApp = angular.module('app.services');
centralApp.factory('categorizacoesApi', categorizacoesSrv);
categorizacoesSrv.$inject = ['$resource', 'ConfigApp'];

function categorizacoesSrv($resource, ConfigApp) {
    return $resource(ConfigApp.UrlApi + '/v1.0/categorizacoes',
        {  }, {
            listarImpactos: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/categorizacoes/impactos',
                ignoreLoadingBar: true,
                cache: true
            },
            listarUrgencias: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/categorizacoes/urgencias',
                ignoreLoadingBar: true,
                cache: true
            },
            listarSituacoes: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/categorizacoes/situacoes',
                ignoreLoadingBar: true,
                cache: true
            },
            listarSituacoesEncerramento: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/categorizacoes/situacoes_encerramento',
                ignoreLoadingBar: true,
                cache: true
            },
            listarCanaisDeAtendimento: {
                method: 'GET',
                isArray: true,
                url: ConfigApp.UrlApi + '/v1.0/categorizacoes/centrais_servico/' + ConfigApp.CentralServicoModuloId + '/canais_atendimento',
                ignoreLoadingBar: true,
                cache: true
            }
        });
};



// WEBPACK FOOTER //
// ./src/services/categorizacoes-api-service.js